import React, { useState, useEffect } from "react";
import './styles/global/global.css';
import config from "./config";
import { 
  Box, 
  Typography, 
  Button, 
  TextField,
  Paper,
  Grid
} from "@material-ui/core";
import {
  Search as SearchIcon,
  Refresh as RefreshIcon
} from "@material-ui/icons";
import Header from "../../layout/header";
import Footer from "../../layout/footer";

function SymbolList() {
  const [symbolsLists, setList] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");
  const [input, setInput] = useState("");

  useEffect(() => {
    const symbols = makeLists();

    const newLists = symbols.map(({ listName, listSymbols }) => {
      const newListSymbols = listSymbols.filter(s =>
        s.toLowerCase().includes(input.toLowerCase())
      );

      return {
        listName: listName.replace('_', ' '),
        listSymbols: newListSymbols
      };
    });

    if (newLists.length) return setList(newLists);

    if (!input.length) return resetList(symbols);

    setErrorMsg("No symbols found matching your search...");
    setList(symbols);
  }, [input]);

  const makeLists = () => {
    const categories = config.categories;
    const lists = [];

    Object.keys(categories).forEach(key => {
      lists.push({
        listName: key.replace('_', ' '),
        listSymbols: categories[key]
      });
    });

    return lists;
  };

  const resetList = symbols => {
    setList(symbols);
    setErrorMsg("");
    setInput("");
  };

  return (
    <>
      <Header />
      
      <Box
        display="flex"
        flexDirection="column"
      
        width="100%"
        minHeight="calc(100vh - 128px)"
        p={3}
        bgcolor="#f5f7fa"
      >
        {/* Search Section */}
        <Paper elevation={3} sx={{ width: '80%', p: 3, mb: 4 }}>
          <br/>
          <Typography variant="h4" component="h1" gutterBottom align="center" color="primary">
            Market Symbols
          </Typography>
          
          <Box 
            display="flex" 
            alignItems="center"
            width="100%"
            mt={3}
            p={2}
            gap={2}
          >
            <TextField
              variant="outlined"
              fullWidth
              onChange={e => setInput(e.target.value)}
              placeholder="Search symbols..."
              value={input}
              InputProps={{
                startAdornment: (
                  
                    <SearchIcon color="action" />
                 
                ),
              }}
              sx={{ flex: 1 }}
            />
            <Button
              variant="outlined"
              color="primary"
              onClick={() => resetList(makeLists())}
              startIcon={<RefreshIcon />}
            
              style={{ margin:"10px"}}
            >
              Reset
            </Button>
          </Box>
        </Paper>

<br/>
        {/* Error Message */}
        {errorMsg && (
          <Typography color="error" align="center" paragraph>
            {errorMsg}
          </Typography>
        )}

        {/* Symbols Grid */}
        <Grid container spacing={3} width="80%">
          {symbolsLists && symbolsLists.map(({ listName, listSymbols }) => (
            <Grid item xs={12} md={6} lg={4} key={listName}>
              <Paper elevation={2} sx={{ height: '100%' }}>
                <Box
                  bgcolor="primary.main"
                  color="white"
                  p={2}
                  borderRadius="4px 4px 0 0"
                >
                  <Typography variant="h6" align="center">
                    {listName.toUpperCase()}
                  </Typography>
                </Box>
                
                <Box
                  maxHeight="400px"
                  overflow="auto"
                  p={2}
                >
                  {listSymbols.map((s, i) => (
                    <Box
                      key={i}
                      p={1.5}
                      mb={1}
                      borderRadius={1}
                      bgcolor="background.paper"
                    >
                      <Typography variant="body1">
                        {s}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>
      
      <Footer />
    </>
  );
}

export default SymbolList;